export default {
  // Add this style to all the reserved spots.
  // In case the spot is part of user's reserved spots, `mySpot` style would be applied
  reservedSpot: {
    className: 's__unavailable'
  },

  // Add this style to all the available spots.
  // In case the spot is part of filter results, `filteredSpot` style would be applied
  availableSpot: {
    className: 's__available'
  },

  // Add this style to the spots that are part of search/filter results.
  filteredArea: {
    className: 's__filtered_area'
  },

  // Add this style to the spots that are part of search/filter results.
  filteredSpot: {
    className: 's__filtered'
  },

  // Add this style to the spots that are part of search/filter results.
  unavailableFilteredSpot: {
    className: 's__unavailable_filtered'
  },

  // Add this style to the spots that are reserved by the user.
  mySpot: {
    className: 's__mine'
  },

  selectedAvailableSpot: {
    className: 's__available_selected'
  },

  selectedUnavailableSpot: {
    className: 's__unavailable_selected'
  }

};



// WEBPACK FOOTER //
// ./src/styles/parkingSpots.js